// Hindu Festival Calendar — 2026 (Comprehensive)
// Source: Standard Drik Panchang. Regional variations may apply.
// Each entry: { date, name, type, description, deity, items }
// type: major | vrat | ekadashi | purnima | amavasya | sankashti | national

export const FESTIVALS_2026 = [
  // ===== JANUARY =====
  { date: "2026-01-03", name: "Paush Putrada Ekadashi", type: "ekadashi",
    description: "Fasting for the blessing of virtuous children. Devotees observe fast and offer prayers to Lord Vishnu.",
    deity: "Lord Vishnu",
    items: ["Tulsi leaves", "Ghee diya", "Yellow flowers", "Panchamrit", "Chandan", "Cotton wicks"] },
  { date: "2026-01-06", name: "Paush Purnima", type: "purnima",
    description: "Full moon of Paush month. Beginning of Magh Snan. Considered highly auspicious for holy dips.",
    deity: "Lord Vishnu & Chandra Dev",
    items: ["Gangajal", "Kapoor", "Ghee for diya", "White flowers", "Rice (akshat)"] },
  { date: "2026-01-14", name: "Makar Sankranti", type: "major",
    description: "The Sun enters Capricorn — Uttarayan begins. Marks the harvest season and longer days. Til-gud shared as a symbol of sweetness.",
    deity: "Surya Dev",
    items: ["Til (sesame) & jaggery", "Kapoor", "Red kalava", "Roli-chandan", "Copper lota", "Ghee & wicks for surya arghya"] },
  { date: "2026-01-14", name: "Pongal", type: "major",
    description: "South Indian four-day harvest festival. Thanksgiving to Surya, cattle, and Mother Earth.",
    deity: "Surya Dev & Bhoomi Devi",
    items: ["Fresh rice & jaggery", "Turmeric plant", "Sugarcane", "Kumkum & haldi", "Cotton wicks", "Ghee diya"] },
  { date: "2026-01-17", name: "Sakat Chauth", type: "sankashti",
    description: "Mothers fast for the well-being and long life of their children. Moon-sighting fast for Lord Ganesh.",
    deity: "Lord Ganesh",
    items: ["Til laddoos", "Durva grass", "Kumkum & chandan", "Red flowers", "Kalash", "Ghee diya"] },
  { date: "2026-01-20", name: "Shattila Ekadashi", type: "ekadashi",
    description: "The 'six sesame' ekadashi. Sesame is used in six ways as offering and consumption.",
    deity: "Lord Vishnu",
    items: ["Til (black sesame)", "Tulsi leaves", "Panchamrit", "Yellow cloth", "Ghee diya"] },
  { date: "2026-01-23", name: "Mauni Amavasya", type: "amavasya",
    description: "Silent fasting day. Considered one of the most auspicious for holy bath at Sangam.",
    deity: "Pitru Devta & Lord Vishnu",
    items: ["Gangajal", "Til", "Kusha grass", "Black sesame til", "Ghee diya", "White flowers"] },
  { date: "2026-01-26", name: "Republic Day", type: "national",
    description: "National holiday commemorating the adoption of the Indian Constitution in 1950.",
    deity: "—",
    items: [] },

  // ===== FEBRUARY =====
  { date: "2026-02-01", name: "Vasant Panchami / Saraswati Puja", type: "major",
    description: "First day of spring. Worship of Devi Saraswati — goddess of learning, music and arts. Children begin studies today (Vidyarambh).",
    deity: "Devi Saraswati",
    items: ["Yellow flowers", "Yellow cloth for Devi", "Kumkum & haldi", "Books & pen (for blessing)", "Kapoor", "Ghee diya", "White chandan"] },
  { date: "2026-02-04", name: "Jaya Ekadashi", type: "ekadashi",
    description: "Fasting frees devotees from evil spirits and grants moksha. Ancient legend of Jaya from Padma Puran.",
    deity: "Lord Vishnu",
    items: ["Tulsi leaves", "Panchamrit", "Yellow flowers", "Ghee diya", "Chandan"] },
  { date: "2026-02-15", name: "Maha Shivratri", type: "major",
    description: "The greatest night of Lord Shiv. Overnight jagran, four-prahar puja, rudrabhishek and fasting.",
    deity: "Lord Shiv",
    items: ["Bel patra (bilva leaves)", "Dhatura", "Bhang", "White chandan", "Ganga jal", "Milk & honey", "Kapoor", "Rudraksh", "Panchamrit", "Ghee diya"] },
  { date: "2026-02-19", name: "Phalguna Amavasya", type: "amavasya",
    description: "New moon of Phalguna month. Traditional day for tarpan and ancestral offerings.",
    deity: "Pitru Devta",
    items: ["Til", "Kusha grass", "Gangajal", "Black flowers", "Ghee diya"] },
  { date: "2026-02-23", name: "Amalaki Ekadashi", type: "ekadashi",
    description: "The amla (Indian gooseberry) tree is worshipped. Believed to house Lord Vishnu and Lakshmi.",
    deity: "Lord Vishnu",
    items: ["Amla fruit", "Tulsi leaves", "Kalash", "Ghee diya", "Yellow flowers", "Panchamrit"] },

  // ===== MARCH =====
  { date: "2026-03-03", name: "Holika Dahan", type: "major",
    description: "Eve of Holi. The bonfire ritual — symbolic burning of Holika and negativity. Prayers offered to the fire.",
    deity: "Agni Dev & Prahlad",
    items: ["Coconut", "Roli & chandan", "Kalawa (mauli)", "Wheat / raw grains", "Kapoor", "Ghee diya", "Cow-dung cakes", "Havan samagri"] },
  { date: "2026-03-04", name: "Holi", type: "major",
    description: "Festival of colours. Celebrates Krishna, spring and community. Gulal and sweets shared.",
    deity: "Lord Krishna & Radha",
    items: ["Natural gulal (colours)", "Sweets & thandai", "Chandan tilak", "Roli & kumkum", "Ghee diya"] },
  { date: "2026-03-06", name: "Phalguna Purnima / Holi Purnima", type: "purnima",
    description: "Full moon of Phalguna. Sacred snan and Satyanarayan katha performed by many households.",
    deity: "Lord Vishnu",
    items: ["Panchamrit", "Tulsi leaves", "Kapoor", "Havan samagri", "Yellow cloth", "Ghee diya"] },
  { date: "2026-03-19", name: "Papmochani Ekadashi", type: "ekadashi",
    description: "Fasting for the removal of past sins. Last ekadashi of the Hindu year.",
    deity: "Lord Vishnu",
    items: ["Tulsi leaves", "Panchamrit", "Yellow flowers", "Ghee diya", "Chandan"] },
  { date: "2026-03-27", name: "Chaitra Navratri Begins", type: "major",
    description: "Nine nights of Devi worship — spring Navratri. Ghatasthapana (kalash sthapna) on day one.",
    deity: "Devi Durga (Nav Durga)",
    items: ["Kalash & coconut", "Red chunari", "Kumkum & haldi", "Red flowers", "Akshat (rice)", "Ghee diya (akhand jyot)", "Havan samagri", "Kalawa", "Chandan"] },

  // ===== APRIL =====
  { date: "2026-04-04", name: "Ram Navami", type: "major",
    description: "Birth of Lord Ram — culmination of Chaitra Navratri. Sundar Kand paath and Ram Raksha stotra.",
    deity: "Lord Ram",
    items: ["Tulsi leaves", "Yellow cloth", "Chandan", "Kapoor", "Panchamrit", "Ghee diya", "Havan samagri"] },
  { date: "2026-04-05", name: "Kamada Ekadashi", type: "ekadashi",
    description: "First ekadashi of the Hindu new year. Grants fulfilment of desires and moksha.",
    deity: "Lord Vishnu",
    items: ["Tulsi leaves", "Panchamrit", "Yellow flowers", "Ghee diya"] },
  { date: "2026-04-11", name: "Hanuman Jayanti", type: "major",
    description: "Birth of Lord Hanuman. Sunrise puja, Hanuman Chalisa paath (108 times auspicious).",
    deity: "Lord Hanuman",
    items: ["Sindoor (with chameli oil)", "Red flowers", "Boondi laddoo (offering)", "Kalawa", "Chandan", "Kapoor", "Ghee diya", "Chola (red cloth)"] },
  { date: "2026-04-14", name: "Baisakhi / Solar New Year", type: "major",
    description: "Solar new year in Punjab and North India. Harvest festival — celebrates the founding of Khalsa (Sikh) & new beginnings.",
    deity: "Surya Dev",
    items: ["Fresh grains", "Til & jaggery", "Ghee diya", "Chandan", "Yellow flowers"] },
  { date: "2026-04-19", name: "Varuthini Ekadashi", type: "ekadashi",
    description: "Fasting grants protection and prosperity. Vishnu's Varaha avatar is remembered.",
    deity: "Lord Vishnu (Varaha)",
    items: ["Tulsi leaves", "Panchamrit", "Yellow flowers", "Ghee diya"] },

  // ===== MAY =====
  { date: "2026-05-04", name: "Akshaya Tritiya", type: "major",
    description: "One of the four most auspicious days of the year. Anything begun/purchased today grows. Traditional day for gold purchases.",
    deity: "Lord Vishnu & Devi Lakshmi",
    items: ["Gold or silver coin", "Tulsi leaves", "Yellow cloth", "Kalash", "Panchamrit", "Ghee diya", "Yellow flowers", "Chandan"] },
  { date: "2026-05-04", name: "Parashuram Jayanti", type: "vrat",
    description: "Birth of Lord Parashuram, the sixth avatar of Vishnu. Fast and puja observed.",
    deity: "Lord Parashuram",
    items: ["Tulsi leaves", "Yellow flowers", "Chandan", "Ghee diya"] },
  { date: "2026-05-15", name: "Ganga Saptami", type: "vrat",
    description: "Celebrates the descent of Devi Ganga to earth on Bhagirath's tapasya.",
    deity: "Devi Ganga",
    items: ["Gangajal", "White flowers", "Ghee diya", "Kapoor", "Chandan"] },
  { date: "2026-05-19", name: "Mohini Ekadashi", type: "ekadashi",
    description: "Vishnu's Mohini avatar is worshipped. Removes all sins and grants liberation.",
    deity: "Lord Vishnu (Mohini)",
    items: ["Tulsi leaves", "Panchamrit", "Yellow flowers", "Ghee diya"] },
  { date: "2026-05-31", name: "Vat Savitri Vrat", type: "vrat",
    description: "Married women fast and tie thread around the banyan tree, praying for husband's long life.",
    deity: "Devi Savitri & Yamraj",
    items: ["Kalawa (red thread)", "Kumkum & haldi", "Chana & fruits", "Ghee diya", "Sindoor", "Bangles & mehendi"] },

  // ===== JUNE =====
  { date: "2026-06-06", name: "Nirjala Ekadashi", type: "ekadashi",
    description: "The most demanding ekadashi — a fast observed without even water. Grants benefits of all 24 ekadashis of the year.",
    deity: "Lord Vishnu",
    items: ["Tulsi leaves", "Kalash with jal", "Ghee diya", "Yellow flowers", "Panchamrit", "Chandan"] },
  { date: "2026-06-20", name: "Ganga Dussehra", type: "major",
    description: "Ten-day festival celebrating Ganga's descent. Devotees bathe in the Ganga.",
    deity: "Devi Ganga",
    items: ["Gangajal", "White & yellow flowers", "Ghee diya", "Kapoor", "Chandan"] },
  { date: "2026-06-27", name: "Devshayani Ekadashi", type: "ekadashi",
    description: "Lord Vishnu enters yog nidra for Chaturmas (four months). Weddings/auspicious functions pause.",
    deity: "Lord Vishnu",
    items: ["Tulsi leaves", "Panchamrit", "Yellow flowers", "Ghee diya", "White cloth"] },

  // ===== JULY =====
  { date: "2026-07-10", name: "Guru Purnima", type: "purnima",
    description: "Devoted to the guru — the one who removes darkness. Also known as Vyasa Purnima.",
    deity: "Guru & Ved Vyas",
    items: ["Kapoor", "Ghee diya", "Chandan", "White flowers", "Yellow cloth", "Rice (akshat)"] },
  { date: "2026-07-13", name: "Kamika Ekadashi", type: "ekadashi",
    description: "First ekadashi of Chaturmas. Removes sins and grants Vishnu's grace.",
    deity: "Lord Vishnu",
    items: ["Tulsi leaves", "Panchamrit", "Yellow flowers", "Ghee diya"] },
  { date: "2026-07-27", name: "Hariyali Teej", type: "vrat",
    description: "Married women's fast for husband's well-being — dedicated to Devi Parvati and her tapasya for Shiv.",
    deity: "Devi Parvati & Lord Shiv",
    items: ["Green bangles", "Mehendi", "Green saree", "Kumkum & sindoor", "Ghee diya", "Kalawa", "Chandan", "Sweets"] },

  // ===== AUGUST =====
  { date: "2026-08-08", name: "Nag Panchami", type: "major",
    description: "Worship of serpent deities. Milk offered to snakes and their images.",
    deity: "Nag Devta",
    items: ["Milk (raw)", "Turmeric", "Rice (akshat)", "Kumkum", "Chandan", "Ghee diya", "Yellow flowers"] },
  { date: "2026-08-15", name: "Independence Day", type: "national",
    description: "National holiday marking India's independence in 1947.",
    deity: "—",
    items: [] },
  { date: "2026-08-15", name: "Raksha Bandhan", type: "major",
    description: "Sisters tie the sacred rakhi thread on brothers' wrists — a bond of protection.",
    deity: "—",
    items: ["Rakhi (sacred thread)", "Roli & chandan", "Rice (akshat)", "Sweets", "Ghee diya", "Coconut"] },
  { date: "2026-08-25", name: "Krishna Janmashtami", type: "major",
    description: "Birth of Lord Krishna at midnight. Fast, jagran, jhula and midnight abhishek.",
    deity: "Lord Krishna",
    items: ["Tulsi leaves", "Panchamrit (for abhishek)", "Yellow cloth", "Peacock feather", "Makhan-mishri", "Ghee diya", "Kapoor", "Chandan", "Yellow flowers"] },

  // ===== SEPTEMBER =====
  { date: "2026-09-05", name: "Ganesh Chaturthi", type: "major",
    description: "Birth of Lord Ganesh. Ten-day festival — sthapna, daily aarti, modak bhog and visarjan.",
    deity: "Lord Ganesh",
    items: ["Ganesh murti (mitti/clay)", "Durva grass (21 blades)", "Modak (offering)", "Red flowers (jasvand)", "Chandan", "Kumkum", "Kapoor", "Ghee diya", "Kalash", "Havan samagri"] },
  { date: "2026-09-14", name: "Anant Chaturdashi", type: "major",
    description: "Final day of Ganesh Chaturthi — Ganesh visarjan. Also Anant Vrat for Lord Vishnu.",
    deity: "Lord Ganesh & Lord Vishnu",
    items: ["Anant sutra (sacred thread)", "Yellow flowers", "Chandan", "Ghee diya", "Panchamrit"] },
  { date: "2026-09-27", name: "Pitru Paksha Begins", type: "major",
    description: "16-day period for tarpan and shraadh — offerings to ancestors. New/auspicious work is paused.",
    deity: "Pitru Devta",
    items: ["Til (black sesame)", "Kusha grass", "Rice balls (pind)", "Gangajal", "Ghee diya", "White flowers", "Barley"] },

  // ===== OCTOBER =====
  { date: "2026-10-11", name: "Sharad Navratri Begins", type: "major",
    description: "Nine nights of Devi worship — the autumn Navratri. Ghatasthapana on day one, akhand jyot lit for 9 days.",
    deity: "Devi Durga (Nav Durga)",
    items: ["Kalash & coconut", "Red chunari", "Kumkum & haldi", "Red flowers", "Akshat", "Akhand jyot wicks", "Havan samagri", "Kalawa", "Chandan", "Kapoor"] },
  { date: "2026-10-19", name: "Durga Ashtami / Maha Ashtami", type: "major",
    description: "Eighth day of Navratri. Kanya pujan performed — nine young girls are worshipped as Devi.",
    deity: "Devi Durga (Maha Gauri)",
    items: ["Poori-halwa-chana (kanya bhog)", "Red chunari", "Kalawa", "Kumkum", "Coins (dakshina)", "Bindi & bangles", "Ghee diya"] },
  { date: "2026-10-20", name: "Vijayadashami / Dussehra", type: "major",
    description: "Victory of good over evil — Ram's victory over Ravan. Effigy burning, Shastra puja and Vahan puja performed.",
    deity: "Lord Ram & Devi Durga",
    items: ["Shami leaves", "Chandan", "Kumkum", "Rice (akshat)", "Ghee diya", "Havan samagri", "Kapoor", "Kalawa"] },
  { date: "2026-10-27", name: "Karva Chauth", type: "vrat",
    description: "Fast by married women from sunrise to moonrise for husband's long life. Sighted through a sieve after moon-arghya.",
    deity: "Devi Karva & Chandra Dev",
    items: ["Karva (clay pot)", "Chalni (sieve)", "Sindoor & bindi", "Kumkum & haldi", "Mehendi", "Bangles", "Kalawa", "Ghee diya", "Sweets"] },

  // ===== NOVEMBER =====
  { date: "2026-11-08", name: "Dhanteras", type: "major",
    description: "First day of Diwali. Lakshmi's arrival. Traditional day to buy gold, silver, utensils and Dhanvantari puja.",
    deity: "Devi Lakshmi & Dhanvantari",
    items: ["Silver or steel utensil", "Kalash", "Kumkum & chandan", "Yellow / red flowers", "Kapoor", "Ghee diya (13 lamps)", "Kalawa", "Coins"] },
  { date: "2026-11-09", name: "Naraka Chaturdashi / Choti Diwali", type: "major",
    description: "Second day of Diwali. Marks Krishna's victory over Narakasura. Abhyang snan at dawn.",
    deity: "Lord Krishna & Yamraj",
    items: ["Til oil (for snan)", "Ubtan / haldi", "Ghee diya (many)", "Kapoor", "Rangoli colours"] },
  { date: "2026-11-10", name: "Diwali / Lakshmi Puja", type: "major",
    description: "Festival of lights. Main Lakshmi-Ganesh puja on Amavasya night at Pradosh Kaal.",
    deity: "Devi Lakshmi & Lord Ganesh",
    items: ["Lakshmi-Ganesh murti", "Silver coin", "Kalash", "Kamal ka phool (lotus)", "Kheel-batasha", "Panchamrit", "Kapoor", "Ghee diya (many)", "Kalawa", "Chandan", "Kumkum", "Rangoli powder", "Havan samagri"] },
  { date: "2026-11-11", name: "Govardhan Puja / Annakut", type: "major",
    description: "Fourth day of Diwali. Krishna lifted Govardhan hill. Annakut — 56 offerings prepared.",
    deity: "Lord Krishna & Govardhan",
    items: ["Cow-dung Govardhan", "Fresh food offerings", "Tulsi leaves", "Yellow flowers", "Ghee diya", "Panchamrit"] },
  { date: "2026-11-12", name: "Bhai Dooj", type: "major",
    description: "Fifth and final day of Diwali. Sisters apply tilak and bless brothers.",
    deity: "Yamraj & Yamuna Devi",
    items: ["Roli & chandan (tilak)", "Rice (akshat)", "Coconut", "Sweets", "Ghee diya"] },
  { date: "2026-11-15", name: "Chhath Puja (Sandhya Arghya)", type: "major",
    description: "Four-day fast for Surya Dev. Special to Bihar & Purvanchal. Sandhya arghya offered to setting sun.",
    deity: "Surya Dev & Chhathi Maiya",
    items: ["Bamboo soop & daura", "Thekua & fresh fruits", "Sugarcane", "Ganne ka rus", "Ghee diya", "Kapoor", "Roli & chandan"] },
  { date: "2026-11-25", name: "Tulsi Vivah", type: "major",
    description: "Symbolic marriage of Tulsi to Shaligram (Lord Vishnu). Marks the end of Chaturmas.",
    deity: "Devi Tulsi & Lord Vishnu",
    items: ["Tulsi plant", "Shaligram / Vishnu idol", "Yellow cloth (chunari)", "Sindoor & haldi", "Ghee diya", "Sugarcane", "Kalash", "Amla"] },

  // ===== DECEMBER =====
  { date: "2026-12-06", name: "Utpanna Ekadashi", type: "ekadashi",
    description: "Traditionally the first ekadashi — birth of Devi Ekadashi from Lord Vishnu.",
    deity: "Lord Vishnu & Devi Ekadashi",
    items: ["Tulsi leaves", "Panchamrit", "Yellow flowers", "Ghee diya"] },
  { date: "2026-12-13", name: "Geeta Jayanti", type: "vrat",
    description: "The day the Bhagavad Geeta was spoken by Krishna to Arjun on the battlefield of Kurukshetra.",
    deity: "Lord Krishna",
    items: ["Bhagavad Geeta (book)", "Tulsi leaves", "Yellow flowers", "Ghee diya", "Chandan", "Panchamrit"] },
  { date: "2026-12-24", name: "Vaikuntha Ekadashi / Mokshada Ekadashi", type: "ekadashi",
    description: "One of the most auspicious ekadashis. Gates of Vaikuntha said to open — grants moksha.",
    deity: "Lord Vishnu",
    items: ["Tulsi leaves", "Panchamrit", "Yellow flowers & cloth", "Ghee diya", "Chandan", "Kapoor"] },
  { date: "2026-12-25", name: "Dattatreya Jayanti", type: "vrat",
    description: "Birth of Lord Dattatreya — the combined form of Brahma, Vishnu and Mahesh.",
    deity: "Lord Dattatreya",
    items: ["Chandan", "Kapoor", "Ghee diya", "Yellow flowers", "Panchamrit"] },
];

export const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

// Traditional Hindu month names (approximate mapping to Gregorian months for context)
export const HINDU_MONTHS = [
  { name: "Pausha / Magha", gregorian: "Jan" },
  { name: "Magha / Phalguna", gregorian: "Feb" },
  { name: "Phalguna / Chaitra", gregorian: "Mar" },
  { name: "Chaitra / Vaishakha", gregorian: "Apr" },
  { name: "Vaishakha / Jyeshtha", gregorian: "May" },
  { name: "Jyeshtha / Ashadha", gregorian: "Jun" },
  { name: "Ashadha / Shravana", gregorian: "Jul" },
  { name: "Shravana / Bhadrapada", gregorian: "Aug" },
  { name: "Bhadrapada / Ashwin", gregorian: "Sep" },
  { name: "Ashwin / Kartika", gregorian: "Oct" },
  { name: "Kartika / Margashirsha", gregorian: "Nov" },
  { name: "Margashirsha / Pausha", gregorian: "Dec" },
];

export function festivalsForMonth(year, monthIndex) {
  const prefix = `${year}-${String(monthIndex + 1).padStart(2, "0")}`;
  return FESTIVALS_2026.filter((f) => f.date.startsWith(prefix));
}

export function festivalsForDate(dateStr) {
  return FESTIVALS_2026.filter((f) => f.date === dateStr);
}

/** Next N upcoming festivals from today. */
export function upcomingFestivals(fromDate = new Date(), limit = 6) {
  const iso = fromDate.toISOString().slice(0, 10);
  return FESTIVALS_2026.filter((f) => f.date >= iso).slice(0, limit);
}
